import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { defaultTheme, greenTheme } from './themes';
import { Alert, CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useConnectivityHandler } from './services/offline/useConnectivityHandler';
import { useCacheHandler } from './services/offline/useCacheHandler';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setErrorVisible } from './store/cache.slice';
import { BetaWarning } from './components/BetaWarning';
import { AddToHomeMessage } from './components/AddToHomeMessage';

function App() {
	useConnectivityHandler();
	useCacheHandler();

	const dispatch = useDispatch();
	const caching = useSelector(state => state.cache.caching);
	const errorVisible = useSelector(state => state.cache.errorVisible);

	const closeError = useCallback(() => {
		dispatch(setErrorVisible(null))
	})

	return (
		<ThemeProvider theme={greenTheme}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<CssBaseline />
				<BetaWarning/>
				<AddToHomeMessage />
				<Router>
					<AppRoutes />
				</Router>
			</LocalizationProvider>
			{caching && <div style={{position: 'absolute', bottom: '20px', fontSize: '12px'}}>Caching...</div>}
			<Alert
				severity="error"
				sx={{ display: errorVisible ? 'flex' : 'none', position: 'fixed', zIndex: 4, bottom: 10, width: '90vw', left: 'calc(50% - 45vw)' }}
				onClose={closeError}>
					{errorVisible}
			</Alert> 
			<div style={{position: 'absolute', bottom: 0, fontSize: '12px'}}>{process.env.REACT_APP_VERSION}</div>
		</ThemeProvider>
	);
}

export default App;
